var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "tr",
    [
      _vm._l(_vm.headers, function (head, i) {
        return _c("th", { key: i, class: _vm.tableHeaderClass }, [
          _vm._v(" " + _vm._s(head) + " "),
        ])
      }),
      _c("th", { staticClass: "px-3 py-3 bg-gray-50 w-1/12" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }